const endpoints = {
	getCompanyClients: '/companies/users/getCompanyClients',
	getCompanyClientsAprovals: '/companies/users/getCompanyClientsAprovals',
	getCompanyClient: '/companies/users/getCompanyClient',
	getAccountByEmail: '/companies/users/getAccountByEmail',
	associateUserToAccount: '/companies/users/associateUserToAccount',
}
export {endpoints}